import { SvgIconComponent } from "@mui/icons-material";
import { SxProps } from "@mui/material";

export interface IDataColumn {
  name: string | null;
  fieldId: string;
  datatype: DTDataGridColumnType;
  callbackFunction?: (e: any, item: any) => void;
  foreColor?: string;
  linkText?: string
  alignment?: DTDataGridAlignment,
  // Functions return values used in rendering; widen return types from void to any/string for correctness.
  dataFunction?: (item: any) => any;
  dataChangeFunction?: (e: any, item: any) => void;
  foreColorFunction?: (item: any) => string | undefined;
  backColorFunction?: (item: any) => string | undefined;
  dataOptions?: Array<any>;
  readonly?: boolean,
  editOnClick?: boolean,
  displayImage?: SvgIconComponent,
  headerClass?: string,
  cellClass?: string,
  sortable?: boolean,
  tabIndex?: number,
  sx?: SxProps
}

export enum DTDataGridColumnType {
  text,
  checkbox,
  dropdownlist,
  link,
  image
}

export enum DTDataGridAlignment {
  left,
  right,
  center
}